import { FC, useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, Step, StepLabel, Stepper } from '@mui/material';
import { AddressSelection } from './AddressSelection';
import { RecipientSelection } from './RecipientSelection';
import { DetailConfirmation } from './DetailConfirmation';
import { useHistory } from 'react-router-dom';
import { DeliveryTimeSelection } from './DeliveryTimeSelection';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  addNewAddress?: () => void;
};

export const OrderSetupModal: FC<Props> = ({ isOpen, onClose, addNewAddress = () => false }) => {
  const [activeStep, setActiveStep] = useState(0);
  const history = useHistory();

  // Reset active step when the modal is closed.
  useEffect(() => {
    !isOpen && setActiveStep(0);
  }, [isOpen]);

  const handleNext = () => {
    if (activeStep === 3) {
      history.push('/orders');
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      data-testid="order-setup-modal"
      PaperProps={{
        style: { borderRadius: 10 },
      }}
    >
      <DialogContent sx={{ marginTop: 2 }}>
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={activeStep}>
            <Step>
              <StepLabel>Select Shipping Address</StepLabel>
            </Step>
            <Step>
              <StepLabel>Choose Recipient</StepLabel>
            </Step>
            <Step>
              <StepLabel>Choose Delivery Time</StepLabel>
            </Step>
            <Step>
              <StepLabel>Confirm Details</StepLabel>
            </Step>
          </Stepper>
          {activeStep === 0 && <AddressSelection handleNext={handleNext} onClose={onClose} addNewAddress={addNewAddress} />}
          {activeStep === 1 && <RecipientSelection handleBack={handleBack} handleNext={handleNext} />}
          {activeStep === 2 && <DeliveryTimeSelection handleBack={handleBack} handleNext={handleNext} />}
          {activeStep === 3 && <DetailConfirmation handleBack={handleBack} handleNext={handleNext} />}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
